import moment from "moment/moment";
export const formatDate = (date) => date ? moment(date).format(`DD.MM.YYYY.`) : "/";
export const formatDateYMD = (date) => moment(date).format(`yyyy-MM-DD`);
export const formatDateAndTime = (date, withSeconds) => date ? moment(date).format(`DD.MM.YYYY. HH:mm${withSeconds ? ":ss" : ""}`) : "/";
export const formatTime = (date, withSeconds) => date ? moment(date).format(`HH:mm${withSeconds ? ":ss" : ""}`) : "/";
export const dateAddDays = (date, addDays) => moment(date).add(addDays, "days").toISOString();
export const checkIfExpired = (date) => date ? moment(new Date()) > moment(date) : true;
export const getCurrentDateFormatted = () => moment().format("DD.MM.YYYY.").toString();
export const getCurrentDateFormattedYMD = () => moment().format("yyyy-MM-DD").toString();
export const getDaysLeft = (date) => moment(date).diff(new Date(), "days");
export const formatYearMonth = (year, month) => `${year}-${month < 10 ? `0${month}` : month}`;
// export const getDayInputRegex = (max: number) =>
//   `(0[1-9]|1[0-9]|2[0-${max === 28 ? "8" : "9"}]${
//     max > 29 && `|3[0${max > 30 && "-1"}]`
//   })`;
